//@flow
import firebase from 'firebase/app';
import 'firebase/firestore';

type CardCreateFormArgs = {
  user?: {
    uid: string,
    displayName: string,
    email: string,
  },
  businessName?: string,
  cardName?: string,
  status?: 'idle' | 'active' | 'banned',
  organizationId?: 'string',
};

export function genSlug(str: string) {
  const r = Math.random()
    .toString(36)
    .slice(-5);

  const init = str ? str + '-' : '';
  return (init + r).replace(' ', '-').toLocaleLowerCase();
}

export function createCard({
  user = null,
  businessName = '',
  cardName = '',
  status = 'idle',
  organizationId = '',
  adsConfig,
}: CardCreateFormArgs) {
  return firebase
    .firestore()
    .collection('cards')
    .add({
      user,
      businessName,
      cardName,
      status,
      slug: genSlug(user?.displayName),
      organizationId,
    });
}
